export const DEFAULT_DURATION_OPTIONS = [
  {
    id: "today",
    label: "Today",
  },
  {
    id: "last-24-hours",
    label: "Last 24 hours",
  },
  {
    id: "last-7-days",
    label: "Last 7 days",
  },
  {
    id: "last-30-days",
    label: "Last 30 days",
  },
  {
    id: "last-month",
    label: "Last Month",
  },
  {
    id: "this-month",
    label: "This Month",
  },
  {
    id: "custom",
    label: "Custom",
  },
] as const;

export type DurationOption = (typeof DEFAULT_DURATION_OPTIONS)[number];
